import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "M1.985 11.304A19.92 19.92 0 0 0 0 20c0 3.116.713 6.066 1.985 8.696L20 30.435l18.015-1.74A19.92 19.92 0 0 0 40 20a19.92 19.92 0 0 0-1.985-8.696L20 9.565l-18.015 1.74Z"
}, null, -1), n = /* @__PURE__ */ l("path", {
  fill: "#6DA544",
  d: "M1.985 28.696C5.219 35.386 12.07 40 20 40s14.78-4.614 18.015-11.304H1.985Z"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M1.985 11.304h36.03C34.781 4.614 27.93 0 20 0S5.22 4.615 1.985 11.304Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#FFDA44",
  d: "M16.522 25.217h6.956v-2.956l-1.391.695L20 20.87l-2.087 2.087-1.391-.695v2.956Zm-3.98-3.478.323.996h1.048l-.848.616.324.997-.847-.616-.848.616.324-.997-.848-.616h1.048l.324-.996Zm1.003-3.479.324.997h1.048l-.848.616.324.996-.848-.615-.847.615.324-.996-.848-.616h1.048l.323-.996Zm2.87-2.608.324.996h1.047l-.847.616.324.997-.848-.616-.847.616.323-.997-.847-.616h1.047l.324-.996Zm11.043 6.087-.323.996h-1.048l.848.616-.324.997.847-.616.848.616-.324-.997.848-.616h-1.048l-.324-.996Zm-1.003-3.479-.324.997h-1.048l.848.616-.324.996.848-.615.847.615-.323-.996.847-.616H26.78l-.324-.996Zm-2.87-2.608-.324.996h-1.047l.847.616-.324.997.848-.616.848.616-.324-.997.847-.616H23.91l-.324-.996ZM20 14.348l.324.996h1.047l-.847.616.324.996-.848-.615-.848.615.324-.996-.848-.616h1.048l.324-.996Z"
}, null, -1), i = [
  o,
  n,
  s,
  c
];
function d(_, a) {
  return t(), e("svg", h, [...i]);
}
const m = { render: d };
export {
  m as default,
  d as render
};
